import { render, staticRenderFns } from "./BadgeListPlatform.vue?vue&type=template&id=751890e5&"
import script from "./BadgeListPlatform.vue?vue&type=script&lang=js&"
export * from "./BadgeListPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751890e5')) {
      api.createRecord('751890e5', component.options)
    } else {
      api.reload('751890e5', component.options)
    }
    module.hot.accept("./BadgeListPlatform.vue?vue&type=template&id=751890e5&", function () {
      api.rerender('751890e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Badges/BadgeListPlatform.vue"
export default component.exports